import React, { useMemo } from "react";

import Login from "../../common/Login/Login";
import { IFeature } from "../../models/admin/features/features";
import { useAppSelector } from "../../store/hooks";
import { RootState } from "../../store/store";
import LoginWithNameAndMobile from "./LoginWithNameAndMobile/LoginWithNameAndMobile";
import LoginWithEmailOrMobile from "./LoginWithEmailOrMobile/LoginWithEmailOrMobile";

const CustomerLogin: React.FC = () => {
  const { features } = useAppSelector((state: RootState) => state.features);
  const loginOptions: IFeature[] = useMemo(
    () =>
      features
        .filter(
          (feature: IFeature) =>
            (feature.featureCode === "name_mobile_login" && feature.selected) ||
            (feature.featureCode === "email_mobile_login" &&
              feature.selected) ||
            (feature.featureCode === "google_login" && feature.selected)
        )
        .sort((a: IFeature, b: IFeature) =>
          a.featureLabel.localeCompare(b.featureCode)
        ),
    [features]
  );

  const renderLoginForm = (loginType: string) => {
    switch (loginType) {
      case "name_mobile_login":
        return <LoginWithNameAndMobile isFunctionable={true} />;
      case "email_mobile_login":
        return <LoginWithEmailOrMobile isFunctionable={true} />;
      default:
        return null;
    }
  };

  return (
    <Login
      showLanguageSelector={true}
      isCustomer={true}
      loginOptions={loginOptions}
      renderLoginForm={renderLoginForm}
    />
  );
};

export default CustomerLogin;
